require('./assetsDistributionChart.scss');

const PropTypes = require('prop-types');

const React= require('react');
const d3 = require('d3');
const isEqual = require('lodash/lang/isEqual');
const reduce = require('lodash/collection/reduce');

const blackBox = props => {

    const {dataset, width, height} = props;

    const chartData = dataset.toJS().map(item => item.Value ?
        item : { Type: item.Type, Value: 0 });

    /** TODO delete once api stable
     *  mocks random data
    const chartData = dataset.toJS().map(item => item.Value ?
        item :
        { Type: item.Type, Value: -Math.random() * 100 });
    */

    return me => {

        const barsG = me.select('.assets-distribution-chart__bars-g');
        const xaxisG = me.select('.assets-distribution-chart__xaxis');
        const yaxisG = me.select('.assets-distribution-chart__yaxis');
        const gridG = me.select('.assets-distribution-chart__grid');
        const tooltip = me.select('.assets-distribution-chart__tooltip');

        const margin = {top: 40, right: 30, bottom: 30, left: 30};
        const availWidth = width - margin.left - margin.right;
        const availHeight = height - margin.top - margin.bottom;

        const maxVal = d3.max(chartData, d => Math.abs(d.Value));

        const x = d3.scale.linear()
            .range([0, availWidth])
            .domain([-maxVal, maxVal]);

        const y = d3.scale.ordinal()
            .rangeRoundBands([0, availHeight], 0.8)
            .domain(chartData.map(d => d.Type));

        const xAxis = d3.svg.axis()
            .scale(x)
            .orient("top");

        const yAxis = d3.svg.axis()
            .scale(y)
            .orient("left")
            .tickSize(0)
            .tickPadding(2);

        barsG.attr("transform", `translate(${margin.left}, ${margin.top})`)
            .selectAll("rect")
            .data(chartData)
                .enter()
            .append("rect")
            .attr("rx", 4)
            .attr("ry", 4)
            .attr("class", d => "assets-distribution-chart__bar assets-distribution-chart__bar--" + d.Type)
            .attr("x", d => x(Math.min(0, d.Value)))
            .attr("y", d => y(d.Type) - 4) // to center the bar in the tick
            .attr("width", d => Math.abs(x(d.Value) - x(0)))
            .attr("height", y.rangeBand())
            .on('mouseenter', d => {
                tooltip
                    .classed('hidden', false)
                    .html(d.Value);
            })
            .on('mousemove', () => tooltip
                .style('left', d3.mouse(me.node())[0] + 'px')
                .style('top', d3.mouse(me.node())[1] + 'px'))
            .on('mouseleave', () => tooltip.classed('hidden', true));

        yaxisG.attr("transform", () => `translate(${x(0) + margin.left}, ${margin.top})` )
            .call(yAxis);

        xaxisG.attr("transform", `translate(${margin.left}, ${margin.top})` )
            .call(xAxis);

        x.ticks().forEach(tick => {
            gridG.append('svg:line')
              .attr({
                x1: () => x(tick),
                x2: () => x(tick),
                y1: 0,
                y2: availHeight,
                'stroke-dasharray': ("2, 3")
              })
              .classed('assets-distribution-chart__horizontal-grid', true);
        });

        y.domain().forEach(tick => {
            gridG.append('svg:line')
              .attr({
                x1: x(-maxVal),
                x2: x(maxVal),
                y1: y(tick) - ((y.rangeBand() * 5) / 2), // 5 because padding is set above in y 0.8
                y2: y(tick) - ((y.rangeBand() * 5) / 2),
                'stroke-dasharray': ("2, 3")
              })
              .classed('assets-distribution-chart__horizontal-grid', true);
        });
        gridG.append('svg:line')
            .attr({
            x1: x(-maxVal),
            x2: x(maxVal),
            y1: availHeight - ((y.rangeBand() * 5) / 2), // 5 because padding is set above in y 0.8
            y2: availHeight - ((y.rangeBand() * 5) / 2),
            'stroke-dasharray': ("2, 3")
            })
            .classed('assets-distribution-chart__horizontal-grid', true);

        gridG.attr("transform", `translate(${margin.left}, ${margin.top})`);

    }
}

class AssetsDistributionChart extends React.Component {

    constructor(props) {
        super(props);
        this.setNode = this.setNode.bind(this);
    }

    componentDidMount() {

        if (!this.props.dataset) 
            { return; }

        d3.select(this.nodeReference)
            .call(blackBox(this.props));
    }

    componentDidUpdate(old) {
        if (!this.props.dataset) 
            { return; }
        // TODO fix this and test it for immutable data
        let difference = reduce(this.props, (result, value, key) => {
            return isEqual(value, old[key]) ? result : result.concat(key);
        }, []);

        if (difference.length === 0) { return; }

        d3.select(this.nodeReference)
            .call(blackBox(this.props));
    }

    setNode(ref) {
        this.nodeReference = ref;
    }

    render() {
        return (
            <div ref={this.setNode} className="assets-distribution-chart">
                <svg width={this.props.width}
                    height={this.props.height}
                    shapeRendering="geometricPrecision"
                >
                    <g className="assets-distribution-chart__grid"></g>
                    <g className="assets-distribution-chart__xaxis"></g>
                    <g className="assets-distribution-chart__yaxis"></g>
                    <g className="assets-distribution-chart__bars-g"></g>
                </svg>
                <div className="assets-distribution-chart__tooltip hidden"></div>
            </div>
        );
    }
}

AssetsDistributionChart.propTypes = {
    dataset: PropTypes.object.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
};

module.exports = AssetsDistributionChart;